import { createHandlerChainRunner, HandlerWithResult } from "@insite/client-framework/HandlerCreator";
import { UploadedItem } from "@insite/client-framework/Store/Components/OrderUpload/OrderUploadState";

export interface ProcessFileParameter {
    products: { partNumber: string; qty: number }[];
}

export interface ProcessFileResult {
    uploadedItems: UploadedItem[];
    uploadLimitExceeded: boolean;
    isBadFile: boolean;
    isUploading: boolean;
    allowCancel: boolean;
}

type HandlerType = HandlerWithResult<ProcessFileParameter, ProcessFileResult>;

export const DispatchBeginProcessFile: HandlerType = props => {
    props.dispatch({
        type: "Components/OrderUpload/BeginProcessFile",
    });
};

export const CreateDefaultResult: HandlerType = props => {
    props.result = {
        uploadedItems: [],
        uploadLimitExceeded: false,
        isBadFile: false,
        isUploading: false,
        allowCancel: false,
    };
};

export const ProcessUploadedFile: HandlerType = props => {
    props.result.isBadFile = props.parameter.products.some(product => Number.isNaN(product.qty));
    if (!props.result.isBadFile) {
        props.result.uploadedItems = [];

        props.parameter.products.forEach(product => {
            const objectToAdd: UploadedItem = {
                name: product.partNumber,
                qtyOrdered: product.qty,
            };

            props.result.uploadedItems.push(objectToAdd);
        });

        props.result.allowCancel = true;
        props.result.isUploading = true;
    }
};

export const DispatchCompleteProcessFile: HandlerType = props => {
    props.dispatch({
        type: "Components/OrderUpload/CompleteProcessFile",
        result: props.result,
    });
};

export const chain = [DispatchBeginProcessFile, CreateDefaultResult, ProcessUploadedFile, DispatchCompleteProcessFile];

const processFile = createHandlerChainRunner(chain, "ProcessFile");
export default processFile;
